/**
 * Sets up the video container by hiding it initially.
 * This container will be shown once the video is ready to play.
 * @returns {HTMLElement} - The video container element.
 */
export function setupVideoContainer() {
  const videoContainer = document.getElementById('videoController');
  videoContainer.style.display = 'none';
  return videoContainer;
}
